'use strict';
/* jshint -W106 */

angular.module('shiftTraderApp')
  .factory('security', function (ServerUrls, $http, $state, Session, OAuthKeys, $rootScope, Users,
                                 $location, EventTrackingService, HardNavigationService, $q) {
    var security = {};

    security.login = function (username, password, doNotRedirect) {
      Session.clearSession();
      return OAuthKeys.getKeys().then(function (keyData) {
        var postData = {
          username: username,
          password: password,
          grant_type: 'password',
          client_id: keyData.uid,
          client_secret: keyData.secret
        };
        return $http.post(ServerUrls.current.railsApi + 'oauth/token', postData)
          .then(function (resp) {
            if (resp && resp.data && resp.data.access_token && !_.isUndefined(resp.data.access_token) && !_.isNull(resp.data.access_token)) {
              Session.setAccessToken(resp.data.access_token);
            }

            if (resp && resp.data && resp.data.refresh_token && !_.isUndefined(resp.data.refresh_token) && !_.isNull(resp.data.refresh_token)) {
              Session.setRefreshToken(resp.data.refresh_token);
            }

            var priorSessionId = Session.getSessionId();

            Session.generateNewSessionId();
            EventTrackingService.addEvent('login_success', { new_uuid: Session.getSessionId(), old_uuid: priorSessionId });


            Session.getMe().then(function(me) {
              console.log('getMe value', me);
              if (me) {
                me.$update({sign_in_count:parseInt(me.sign_in_count) + 1});
                $rootScope.$broadcast('loginStateChanged', {state: true});
              }

              if (!doNotRedirect) {
                console.log('authFailureOccurred: ', $rootScope.authFailureOccurred);
                console.log('transitioningToRoute:', $rootScope.transitioningToRoute);
                console.log('currentRoute:', $rootScope.currentRoute);

                if ($rootScope.authFailureOccurred) {
                  if ($rootScope.transitioningToRoute) {
                    $state.go($rootScope.transitioningToRoute.state, $rootScope.transitioningToRoute.params, {reload: true});
                  } else {
                    $state.go($rootScope.currentRoute.state, $rootScope.currentRoute.params, {reload: true});
                  }
                  $rootScope.authFailureOccurred = false;
                } else {
                  HardNavigationService.navigateTo('enter');
                }
              }
            }, function() {
              if (!doNotRedirect) {
                console.log('authFailureOccurred: ', $rootScope.authFailureOccurred);
                console.log('transitioningToRoute:', $rootScope.transitioningToRoute);
                console.log('currentRoute:', $rootScope.currentRoute);
                if ($rootScope.authFailureOccurred) {
                  if ($rootScope.transitioningToRoute) {
                    $state.go($rootScope.transitioningToRoute.state, $rootScope.transitioningToRoute.params, {reload: true});
                  } else {
                    $state.go($rootScope.currentRoute.state, $rootScope.currentRoute.params, {reload: true});
                  }
                  $rootScope.authFailureOccurred = false;
                } else {
                  HardNavigationService.navigateTo('enter');
                }
              }
            });
            return resp;
          }, function(response) {
            EventTrackingService.addEvent('login_failure', { old_uuid: Session.getSessionId() });
            return $q.reject(response);
          });
      });

    };

    return security;
  });
